// import { useEffect, useState } from 'react';
// import Select from 'react-select';
// import { useTranslation } from 'react-i18next';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import useGetInventoryItems from '@hooks/INV/MasterItems/useGetInventoryItems';

// import Loading from '@components/Shared/Loader/Loading';
// import confirmAction from '@components/Shared/Alert/confirmAction';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import NtxTable from '@components/DataTable/NtxTable';
// import {
//   assignmentAttributeToMultiItems,
//   deleteAssignmentAttribute,
//   getItemAttributByAttributeId
// } from '@store/INV/Attributes/AttributesSlice';

// interface Props {
//   attributId: string;
// }

// const AttributeItems = ({ attributId }: Props) => {
//   const { i18n, t } = useTranslation();
//   const dispatch = useAppDispatch();
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [item, setItem] = useState<any>('');
//   const { loading2, error2 } = useAppSelector(s => s.Attributes);

//   const { InventoryItemsOptions, loading, error } = useGetInventoryItems();

//   const ItemsOptions = InventoryItemsOptions.map(m => ({
//     value: `${m.itemId}|${m.uom}`,
//     label: m.itemName,
//     itemId: m.itemId,
//     uom: m.uom,
//     uomName: m.uomName
//   }));

//   useEffect(() => {
//     if (attributId) {
//       dispatch(getItemAttributByAttributeId(attributId));
//     }
//   }, [attributId, dispatch]);

//   const onAdd = () => {
//     setIsSubmitting(true);

//     const body = {
//       itemIds: [{ itemId: item.itemId, uom: item.uom }],
//       attributeId: attributId
//     };
//     dispatch(assignmentAttributeToMultiItems(body))
//       .unwrap()
//       .then(res => {
//         if (res.succeeded) {
//           CustomAlert({ action: 'Add' });
//           dispatch(getItemAttributByAttributeId(attributId));
//         } else {
//           CustomAlert({ action: 'Error', msg: res.message });
//         }
//       })
//       .catch((error: any) => {
//         CustomAlert({ action: 'Error' });
//       })
//       .finally(() => {
//         setIsSubmitting(false);
//       });
//   };

//   // deleteAssignmentAttribute

//   return (
//     <>
//       <Loading loading={loading || loading2} error={error || error2} Type='Dots'>
//         <div className='input-group flex-nowrap align-items-center mb-1'>
//           <span className='input-group-text fw-bold  px-3'>{t('الصنف')}</span>

//           <Select
//             classNamePrefix='react-select'
//             className='flex-grow-1 me-2'
//             isSearchable
//             isClearable
//             // options={InventoryItemsOptions}
//             options={ItemsOptions}
//             onChange={option => setItem(option === null ? null : option)}
//             placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//             menuPortalTarget={document.body}
//             formatOptionLabel={option => (
//               <div className='d-flex justify-content-between   '>
//                 <div className=''>{option.label}</div>
//                 <div className='text-theme fw-bold'>{option.uomName}</div>
//               </div>
//             )}
//             styles={{
//               menuPortal: base => ({ ...base, zIndex: 9999 })
//             }}
//           />

//           <button
//             disabled={isSubmitting || !item}
//             type='button'
//             className='btn btn-theme d-flex align-items-center px-3 rounded-0'
//             onClick={onAdd}
//           >
//             {isSubmitting ? (
//               <div className='spinner-border spinner-border-sm me-2'></div>
//             ) : (
//               <i className='fas fa-plus fa-lg fa-fw me-2'></i>
//             )}
//             {t('Add')}
//           </button>
//         </div>

//         <List attributId={attributId} InventoryItemsOptions={InventoryItemsOptions} />
//       </Loading>
//     </>
//   );
// };

// export default AttributeItems;

// const List = ({ attributId, InventoryItemsOptions }: { attributId: string; InventoryItemsOptions: any[] }) => {
//   const { i18n, t } = useTranslation();
//   const dispatch = useAppDispatch();

//   const { ItemByAttribute: data } = useAppSelector(s => s.Attributes);

//   const handleDelete = async (item: any) => {
//     console.log(item);

//     const isConfirm = await confirmAction('هل أنت متأكد من عملية الحذف');
//     if (!isConfirm) {
//       return;
//     }
//     // deleteAssignmentAttribute
//     dispatch(
//       deleteAssignmentAttribute({
//         itemId: item.itemId,
//         uom: item.uom,
//         attributeId: item.attributeId
//       })
//     )
//       .unwrap()
//       .then(() => {
//         dispatch(getItemAttributByAttributeId(attributId));
//         CustomAlert({ action: 'Delete' });
//       })
//       .catch(error => {
//         CustomAlert({ action: 'Error' });
//       });
//   };

//   const columns = [
//     { title: t('الصنف'), key: 'item' },
//     { title: t('الوحدة'), key: 'uom' },
//     { title: '', key: 'action', className: 'text-end' }
//   ];

//   const tableData =
//     data?.map(item => {
//       let rowClass;

//       const itemName = InventoryItemsOptions.find((f: any) => f.value === item.itemId)?.label;
//       const uomName = InventoryItemsOptions.find((f: any) => f.value === item.itemId)?.uomName;

//       return {
//         item: itemName,
//         uom: uomName,
//         action: (
//           <button type='button' className='btn  btn-outline-danger' onClick={() => handleDelete(item)}>
//             <i className='fas fa-lg fa-trash-alt'></i>
//           </button>
//         )
//       };
//     }) || [];

//   return (
//     <>
//       <NtxTable
//         data={tableData || []}
//         columns={columns || []}
//         dataPerPage={5}
//         theadClass=''
//         tableClass='table text-nowrap table-hover '
//       />
//     </>
//   );
// };




import { useEffect, useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import useGetInventoryItems from '@hooks/INV/MasterItems/useGetInventoryItems';

import Loading from '@components/Shared/Loader/Loading';
import confirmAction from '@components/Shared/Alert/confirmAction';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import NtxTable from '@components/DataTable/NtxTable';
import {
  assignmentAttributeToMultiItems,
  deleteAssignmentAttribute,
  getItemAttributByAttributeId
} from '@store/INV/Attributes/AttributesSlice';

interface Props {
  attributId: string;
}

const AttributeItems = ({ attributId }: Props) => {
  const { i18n, t } = useTranslation();
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [item, setItem] = useState<any>('');
  const { loading2, error2 } = useAppSelector(s => s.Attributes);

  const { InventoryItemsOptions, loading, error } = useGetInventoryItems();

  const ItemsOptions = InventoryItemsOptions.map(m => ({
    value: `${m.itemId}|${m.uom}`,
    label: m.itemName,
    itemId: m.itemId,
    uom: m.uom,
    uomName: m.uomName
  }));

  useEffect(() => {
    if (attributId) {
      dispatch(getItemAttributByAttributeId(attributId));
    }
  }, [attributId, dispatch]);

  const onAdd = () => {
    setIsSubmitting(true);

    const body = {
      itemIds: [{ itemId: item.itemId, uom: item.uom }],
      attributeId: attributId
    };
    dispatch(assignmentAttributeToMultiItems(body))
      .unwrap()
      .then(res => {
        if (res.succeeded) {
          CustomAlert({ action: 'Add' });
          dispatch(getItemAttributByAttributeId(attributId));
        } else {
          CustomAlert({ action: 'Error', msg: res.message });
        }
      })
      .catch((error: any) => {
        CustomAlert({ action: 'Error' });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <Loading loading={loading || loading2} error={error || error2} Type='Dots'>
        <div className='input-group flex-nowrap align-items-center mb-1'>
          <span className='input-group-text fw-bold  px-3'>{t('Item')}</span>

          <Select
            classNamePrefix='react-select'
            className='flex-grow-1 me-2'
            isSearchable
            isClearable
            options={ItemsOptions}
            onChange={option => setItem(option === null ? null : option)}
            placeholder={t('Choose')}
            menuPortalTarget={document.body}
            formatOptionLabel={option => (
              <div className='d-flex justify-content-between   '>
                <div className=''>{option.label}</div>
                <div className='text-theme fw-bold'>{option.uomName}</div>
              </div>
            )}
            styles={{
              menuPortal: base => ({ ...base, zIndex: 9999 })
            }}
          />

          <button
            disabled={isSubmitting || !item}
            type='button'
            className='btn btn-theme d-flex align-items-center px-3 rounded-0'
            onClick={onAdd}
          >
            {isSubmitting ? (
              <div className='spinner-border spinner-border-sm me-2'></div>
            ) : (
              <i className='fas fa-plus fa-lg fa-fw me-2'></i>
            )}
            {t('Add')}
          </button>
        </div>

        <List attributId={attributId} InventoryItemsOptions={InventoryItemsOptions} />
      </Loading>
    </>
  );
};

export default AttributeItems;

const List = ({ attributId, InventoryItemsOptions }: { attributId: string; InventoryItemsOptions: any[] }) => {
  const { i18n, t } = useTranslation();
  const dispatch = useAppDispatch();

  const { ItemByAttribute: data } = useAppSelector(s => s.Attributes);

  const handleDelete = async (item: any) => {
    const isConfirm = await confirmAction(t('ConfirmDelete'));
    if (!isConfirm) {
      return;
    }
    
    dispatch(
      deleteAssignmentAttribute({
        itemId: item.itemId,
        uom: item.uom,
        attributeId: item.attributeId
      })
    )
      .unwrap()
      .then(() => {
        dispatch(getItemAttributByAttributeId(attributId));
        CustomAlert({ action: 'Delete' });
      })
      .catch(error => {
        CustomAlert({ action: 'Error' });
      });
  };

  const columns = [
    { title: t('Item'), key: 'item' },
    { title: t('Unit'), key: 'uom' },
    { title: '', key: 'action', className: 'text-end' }
  ];

  const tableData =
    data?.map(item => {
      const itemName = InventoryItemsOptions.find((f: any) => f.value === item.itemId)?.label;
      const uomName = InventoryItemsOptions.find((f: any) => f.value === item.itemId)?.uomName;

      return {
        item: itemName,
        uom: uomName,
        action: (
          <button type='button' className='btn  btn-outline-danger' onClick={() => handleDelete(item)}>
            <i className='fas fa-lg fa-trash-alt'></i>
          </button>
        )
      };
    }) || [];

  return (
    <>
      <NtxTable
        data={tableData || []}
        columns={columns || []}
        dataPerPage={5}
        theadClass=''
        tableClass='table text-nowrap table-hover '
      />
    </>
  );
};
